import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MdDialog, MdDialogRef} from '@angular/material';
import {AuthentificationService} from './authentification.service';
import {AppComponent} from './app.component';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';


@Component({
    selector: 'super-users-authentification',
    styleUrls: ['./styles/authentification.component.css'],
    templateUrl: './templates/super_users_authentification.component.html',
    providers: [AuthentificationService]
})


export class SuperUsersAuthentificationComponent {
    name = 'Authentification';
    societies_list: Array<Object>;
    society: string;
    user_name: string = "";
    password: string = "";
    connected: boolean = false;
    showForm: boolean = true;
    authentification_form: FormGroup;
    false_login: boolean = false;

    constructor(private authentification_service: AuthentificationService, private app_component: AppComponent, private router: Router, private fb: FormBuilder) {
        this.createForm();
        this.SuperUserCheckSession();
        this.app_component.HideMenu();

        //this.left_menu.current_item = 0;
    }


    SuperUserCheckSession(): void {

        this.authentification_service.SuperUserCheckSession().then(result => {
            if (result['id_super_user'] !== 0) {this.router.navigate(['admin/warehouse'])}

        });
    }

    createForm() {
        this.authentification_form = this.fb.group({
            user_name_ctrl: ['', Validators.required],
            password_ctrl: ['', Validators.required],
        });
    }

    /*GetSocietes(): void {
        this.authentification_service.GetSocities().then(result => {this.societies_list = result['list']; console.log(this.societies_list)});
    }*/

    ValidateIdentifiant(): void {
        //this.connected = true;
        if (this.authentification_form.status === 'VALID') {
            this.connected = true;
            this.authentification_service.ValidateSuperUsersAuthentification(this.user_name, this.password).then(result => {
                //console.log(result);
                setTimeout(() => {
                    if (result['result'] === 'OK') {
                        this.router.navigate(['admin/warehouse']);
                        
                        //this.app_component.m_opened = true;
                    } else {
                        this.connected = false;
                        this.false_login = true;
                        setTimeout(() => {this.false_login = false;}, 4000);
                    }

                }, 2000);
                //setTimeout(() => {this.router.navigate(['dashboard']); this.app_component.m_opened = true;}, 2000);
            });
        }
    }


    /*IsValidForm(): void {
        //console.log(this.user_name + this.password + this.society);
        if (this.user_name !== "" && this.password !== "" && this.society !== "") {

        } else {

        }
    }*/

    LogOut(): void {
        this.authentification_service.LogOut().then(result => {console.log(result)});
    }

    Reset(): void {
        this.authentification_form.reset();
        this.showForm = false;
        setTimeout(() => {

            this.createForm();
            this.showForm = true;
        });

    }

    UserCheckSession(): void {
        this.authentification_service.UserCheckSession().then(result => {console.log(result)});
    }

    ngOnInit(): void {
    }

}






// WEBPACK FOOTER //
// ./src/app/super_users_authentification.component.ts